// Device preference, not an authorization token. The server validates every request.
// Always scope the selected register to authenticated user + company + branch.
const getStore = () => (typeof localStorage !== 'undefined' ? localStorage : null);
export function registerIdentity(state={}) {
  const c=state.context||{},u=state.user||{};
  const company=Number(c.company?.id||0),branch=Number(c.branch?.id||0),user=Number(u.id||0);
  return {company,branch,user};
}
const key = (ctx,type) => `gt-pos-2b-${type}:${Number(ctx.company||0)}:${Number(ctx.branch||0)}:${Number(ctx.user||0)}`;
export function getSelectedRegister(ctx) {
  try { const value=Number(getStore()?.getItem(key(ctx,'register'))||0);return Number.isSafeInteger(value)&&value>0?value:0; }
  catch (_e) { return 0; }
}
export function setSelectedRegister(ctx,id) {
  const value=Number(id);
  if (!Number.isSafeInteger(value)||value<0) throw new Error('Registro inválido.');
  const storage=getStore(); if (!storage) throw new Error('Este dispositivo no permite guardar su caja.');
  if (value) storage.setItem(key(ctx,'register'),String(value));
  else storage.removeItem(key(ctx,'register'));
}
export function isMultiRegisterEnabled(ctx) {
  try { return getStore()?.getItem(key(ctx,'mode'))==='enabled'; } catch (_e) { return false; }
}
export function isRegisterModeKnown(ctx) {
  try { return ['enabled','disabled'].includes(getStore()?.getItem(key(ctx,'mode'))); } catch (_e) { return false; }
}
export function setMultiRegisterEnabled(ctx,enabled) {
  const storage=getStore(); if (!storage) throw new Error('No se puede guardar el modo de caja en este dispositivo.');
  if (enabled) storage.setItem(key(ctx,'mode'),'enabled');
  else { storage.setItem(key(ctx,'mode'),'disabled'); storage.removeItem(key(ctx,'register')); }
}
